import { styled } from "@mui/material";

export const StyledMultiValuesContainer = styled("div")`
  display: flex;
  align-self: stretch;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[1]};
  justify-content: space-between;
  max-width: 60%;
  position: relative;
`;

export const StyledContentContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[1]};

  & .OverflowedTag {
    display: none;
  }
`;

export const StyledMoreItems = styled("span")`
  line-height: 1;
  color: ${({ theme }) => theme.wsc.palette.primary.contrastText};
`;

export const StyledShadowContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[1]};
  visibility: hidden;
  position: absolute;
  width: 100%;
`;
